export default __webpack_public_path__ + "static/media/PullOverDesignResistance.0eb6361a.svg";